module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-popover', {
    attrs: {
      "placement": "right",
      "title": "",
      "trigger": "click"
    }
  }, [_c('img', {
    attrs: {
      "slot": "reference",
      "src": _vm.imgSrc
    },
    slot: "reference"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgSrc
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-feef93a0!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PopoverImg.vue
// module id = 309
// module chunks = 0